import { Menu } from 'lucide-react'
import { Logo } from '../components/Logo'
import { SearchBar } from '../components/SearchBar'
import { HotlineBadge } from '../components/HotlineBadge'
import { CartBadge } from '../components/CartBadge'
import { MainNav } from '../components/MainNav'
import { CategorySidebar } from '../components/CategorySidebar'
import { useMobileMenuStore } from '../../state/mobileMenuStore'

export function Header() {
  const openMenu = useMobileMenuStore((s) => s.openMenu)

  return (
    <header className="bg-surface border-b border-border shadow-card">
      <div className="max-w-[1440px] mx-auto px-4 lg:px-6 py-3 lg:py-4 flex items-center gap-3 lg:gap-6">
        <button
          onClick={openMenu}
          className="lg:hidden w-10 h-10 rounded-md hover:bg-brand-50 text-brand-600 flex items-center justify-center shrink-0"
          aria-label="Mở menu"
        >
          <Menu className="w-6 h-6" />
        </button>
        <Logo />
        <div className="hidden md:flex flex-1"><SearchBar /></div>
        <div className="hidden xl:flex"><HotlineBadge /></div>
        <CartBadge />
      </div>
      <div className="md:hidden px-4 pb-3">
        <SearchBar />
      </div>
      <div className="border-t border-border hidden lg:block">
        <div className="max-w-[1440px] mx-auto px-6 flex items-stretch gap-6">
          <div className="w-[280px] shrink-0 hidden lg:block" />
          <MainNav />
        </div>
      </div>
    </header>
  )
}

export { CategorySidebar }
